import React, { useState } from 'react';
import { useDarkMode } from '../../../../contexts/DarkModeContext';
import { templatePreviewUrl } from '../../../../utils/templatePreviewUrl';
import { groupByLayout } from '../../../../utils/templateCatalogPolicy';

const TemplatePreview = ({ template, isDarkMode }) => {
  const [imgError, setImgError] = useState(false);

  if (template.preview && !imgError) {
    return (
      <img
        src={templatePreviewUrl(template.preview)}
        alt=""
        loading="lazy"
        onError={(e) => { e.currentTarget.style.display = 'none'; setImgError(true); }}
        className="w-full aspect-[8/5] object-cover rounded-lg mb-2"
      />
    );
  }

  return (
    <div className={`w-full aspect-[8/5] rounded-lg mb-2 flex items-center justify-center text-center px-2 ${
      isDarkMode ? 'bg-[#2A2A2A] text-white' : 'bg-gray-300 text-gray-900'
    }`}>
      {template.name}
    </div>
  );
};

export const TemplateGrid = ({ templates, selectedTemplate, onSelect, showPortraitDivider }) => {
  const { isDarkMode } = useDarkMode();

  // The resolved list keeps the clock's reported order (landscape/portrait can be
  // interleaved); group it so the divider heading below is placed correctly and all
  // portrait rows land after it, instead of mislabeling whatever row happens to be first.
  const grouped = groupByLayout(templates);
  let dividerShown = false;

  return (
    <div className="grid grid-cols-2 gap-3 relative z-0">
      {grouped.map((template) => {
        const showDivider = showPortraitDivider && !dividerShown && template.layout === 'portrait';
        if (showDivider) {
          dividerShown = true;
        }

        const unavailable = template.availableOnClock === false;

        return (
          <React.Fragment key={template.id}>
            {showDivider && (
              <div className="col-span-2 pt-6 pb-3">
                <h3 className={`text-lg font-medium mb-1 ${
                  isDarkMode ? 'text-white' : 'text-gray-900'
                }`}>
                  Portrait Photo Templates
                </h3>
                <p className={`text-sm ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>
                  Templates optimized for portrait orientation photos
                </p>
                <div className={`mt-3 border-b ${
                  isDarkMode ? 'border-white/10' : 'border-gray-200'
                }`} />
              </div>
            )}
            <div
              onClick={unavailable ? undefined : () => onSelect(template)}
              className={`p-4 rounded-xl transition-all duration-200 ${
                unavailable
                  ? 'opacity-50 cursor-not-allowed'
                  : 'cursor-pointer'
              } ${
                isDarkMode
                  ? 'bg-[#1A1A1A] hover:bg-[#222222]'
                  : 'bg-gray-100 hover:bg-gray-200'
              } ${
                selectedTemplate === template.id
                  ? isDarkMode
                    ? 'ring-2 ring-emerald-500'
                    : 'ring-2 ring-emerald-600'
                  : ''
              }`}
            >
              <TemplatePreview template={template} isDarkMode={isDarkMode} />
              <h3 className={`text-base font-medium mb-1 ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}>
                {template.name}
              </h3>
              <p className={`text-sm ${
                isDarkMode ? 'text-gray-400' : 'text-gray-600'
              }`}>
                {unavailable ? 'Not available on your clock' : template.description}
              </p>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};
